// extracted by mini-css-extract-plugin
export default {"text":"HeaderButton_text__uMaq8","headerButton":"HeaderButton_headerButton__J53Wj"};